import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ElementRef,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";
import { Router } from "@angular/router";

import { ConfigurationService, UrlService } from "@/shared-module/services";
import { Configuration, Submenu } from "@/shared-module/models";

@Component({
  selector: "app-submenu-singlelevel",
  templateUrl: "submenusinglelevel.component.html",
})
export class SubmenuSingleLevelComponent implements OnInit, OnDestroy {
  @Input() data: Submenu;
  @ViewChild("template", { static: true }) template;
  @ViewChild("stickyMenu") menuElement: ElementRef;

  path: string;
  root: string;
  subpath: string;
  page: string;
  cssColor: string;
  sticky = false;
  menuPosition: any;
  subs = new SubSink();
  urlParams: any;

  constructor(
    private router: Router,
    private urlService: UrlService,
    private configurationService: ConfigurationService,
    private viewContainerRef: ViewContainerRef,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => (thisObject.cssColor = c.cssColor + "-inv"),
    );

    this.subs.sink = router.events.subscribe((data: any) => {
      if (data.url) {
        let location = this.getUrlPath(data.url);
        this.urlParams = this.getUrlParams(data.url);
        const knownRoots = this.urlService.getKnownRoots();
        knownRoots.forEach((r) => {
          if (location.startsWith(r + "/")) {
            this.root = r;
          }
        });

        if (this.root) {
          location = location.replace(this.root, "");
        }

        if (location) {
          const splitted = location.split("/");
          thisObject.page = splitted[1];
          if (splitted.length >= 4) {
            thisObject.path = splitted[2];
            thisObject.subpath = splitted[3];
          } else if (splitted.length >= 3) {
            thisObject.path = splitted[2];
            thisObject.subpath = "";
          } else if (thisObject.data && thisObject.data.items.length >= 1) {
            thisObject.path = thisObject.data.items[0].value;
            thisObject.subpath = "";
          }
        }
      }
    });
  }

  @HostListener("window:scroll", ["$event"]) handleScroll() {
    if (this.menuElement) {
      if (!this.menuPosition) {
        this.menuPosition = this.menuElement.nativeElement.offsetTop;
      }
      const windowScroll = window.pageYOffset;
      if (windowScroll >= this.menuPosition) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
    }
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getUrlParams(queryString) {
    // remove any preceding url and split
    queryString = queryString
      .substring(queryString.indexOf("?") + 1)
      .split("&");
    const params = {};
    let pair = null;
    const d = decodeURIComponent;
    // march and parse
    for (let i = queryString.length - 1; i >= 0; i--) {
      pair = queryString[i].split("=");
      params[d(pair[0])] = d(pair[1] || "");
    }

    return params;
  }

  getUrlPath(search) {
    if (search.indexOf("?") > 0) {
      return search.substring(0, search.indexOf("?"));
    }
    return search;
  }

  getPage() {
    if (this.root != null && this.page != null && this.page !== "") {
      return this.root + "/" + this.page;
    } else if (this.page != null && this.page !== "") {
      return this.page;
    }
    return "dashboard";
  }

  getSelectedPath() {
    if (!this.path && this.data && this.data.items.length >= 1) {
      this.path = this.data.items[0].value;
    }
    if (this.path) {
      return this.path;
    }
  }
}
